module.exports = __webpack_public_path__ + "img/carve_step4.7750db7a.png";